<template>
  <FluxoCompletoComponent :category="1" :title="'Fluxo Completo EPIS'" />
</template>

<script>
import FluxoCompletoComponent from "../components/FluxoCompletoComponent.vue";
export default {
  components: {
    FluxoCompletoComponent,
  },
};
</script>

<style></style>
